import { useState, useMemo, useEffect } from 'react';
import './App.css';
import { SlideCountdown } from 'react-fancy-countdown';
import 'react-fancy-countdown/dist/countdown.css';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { green, purple } from '@mui/material/colors';

const Due = () => (
  <div className="due">
    <img src="https://intl.stagecrowd.live/images/48/d22/3dbb236572d281bbfc557f204d130.jpg" alt="cover" height="300vh"></img>
    <br />
    Go watch the live!
    <br />
    <a href="https://intl.stagecrowd.live/s/scint/group/detail/i10069">https://intl.stagecrowd.live/s/scint/group/detail/i10069</a>
  </div>
);

const targetTitle = "Kessoku Band Concert-Fixed Star-"
const targetUsername = "happy_birthday_victor@yikuo.dev"
const targetPassword = "2rjugeorge"

const choices1 = "abcdefghijklmnopqrst"
const choices2 = "uvwxyz0123456789._-@ "

const getStartedMillis = () => {
  const curDate = new Date();
  return curDate.getTime() - 1684468800000;
}

const getTotalGuesses = () => Math.floor(getStartedMillis() / 3600000);

const getRemainingSecs = () => {
  return Math.floor((3600000 - (getStartedMillis() % 3600000)) / 1000)
}


function App() {
  const [guessed, setGuessed] = useState("");
  const [totalGuesses, setTotalGuesses] = useState(getTotalGuesses());
  const [remainingSecs, setRemainingSecs] = useState(getRemainingSecs());

  useEffect(() => {
    const saved = localStorage.getItem("guessed");
    if (saved)
      setGuessed(saved);
    console.log(saved)
  }, []);


  useEffect(() => {
    localStorage.setItem("guessed", guessed);
  }, [guessed]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTotalGuesses(getTotalGuesses())
      setRemainingSecs(getRemainingSecs())
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const remainingGuesses = useMemo(() =>
    totalGuesses - guessed.length
    // Math.max(0, totalGuesses - guessed.length)
  , [totalGuesses, guessed])
  
  const titleGuessResult = useMemo(() =>
    [...targetTitle].map(c => guessed.includes(c.toLowerCase())? c: '^')
  , [guessed])
  const userGuessResult = useMemo(() =>
    [...targetUsername].map(c => guessed.includes(c.toLowerCase())? c: '^')
  , [guessed])
  const passGuessResult = useMemo(() =>
    [...targetPassword].map(c => guessed.includes(c.toLowerCase())? c: '^')
  , [guessed])



  return (
    <div className="App">
      <header className="App-header">
        <Stack direction="row" spacing={0.5}>
          {
            titleGuessResult.map((c, i) =>
              <Avatar key={i} sx={{bgcolor: c === '^'? null: purple['700']}}>
                {c === '^'? '': c}
              </Avatar>
            )
          }
        </Stack>
        <br></br>

        {
          (!titleGuessResult.includes('^') && !userGuessResult.includes('^') && !passGuessResult.includes('^'))  && 
          <Due />
        }
        <br></br>

        <SlideCountdown
          deadline="2023-05-21 17:00:00"
          weeks={false}
          callback={ () => {
            setGuessed(choices1 + choices2)
          }}
          dueElement={null}
        />
        
        <br />
        <br />
        <Stack direction="row" spacing={0.5}>
          {
            userGuessResult.map((c, i) =>
              <Avatar key={i} sx={{bgcolor: c === '^'? null: green['700']}}>
                {c === '^'? '': c}
              </Avatar>
            )
          }
        </Stack>
        <br />
        <Stack direction="row" spacing={0.5}>
        {
            passGuessResult.map((c, i) =>
              <Avatar key={i} sx={{bgcolor: c === '^'? null: green['700']}}>
                {c === '^'? '': c}
              </Avatar>
            )
          }
        </Stack>
        <br />
        <br />
        <Stack direction="row" spacing={0.5}>
          {
            [...choices1].map((c, i) =>
              <Button
                key={i} 
                variant="contained"
                sx={{
                  width: 64,
                  height: 64,

                  borderRadius: 8,
                }}
                color={remainingGuesses > 0? "info": "error"}
                disabled={guessed.includes(c)}
                onClick={() => {
                  if (remainingGuesses > 0)
                    setGuessed(guessed + c)
                }}
              >
                {c}
              </Button>
            )
          }
        </Stack>
        <Stack direction="row" spacing={0.5}>
          {
            [...choices2].map((c, i)=>
              <Button
                key={i}
                variant="contained"
                sx={{
                  width: 64,
                  height: 64,

                  borderRadius: 8,
                }}
                color={remainingGuesses > 0? "info": "error"}
                disabled={guessed.includes(c)}
                onClick={() => {
                  if (remainingGuesses > 0)
                    setGuessed(guessed + c)
                }}
              >
                {c}
              </Button>
            )
          }
        </Stack>
        <br></br>
        Remaining guesses: {remainingGuesses}
        <br></br>
        +1 in {remainingSecs} seconds
      </header>
    </div>
  );
}

export default App;
